import $ from "jquery";

export function SetSelected(rows) {
    if (!rows) {
        return
    }
    const table = $("#example");
    table.DataTable().rows().deselect()

    for (const row of rows) {
        table.DataTable().row(`[rowid=${row}]`).select()
    }

    $('span.items').text(rows.length + ' ');

    return rows;
}

export function DoubleClickSelected(row) {
    if (!row || row === "undefined") {
        return
    }
    const table = $("#example");
    $('[rowid="' + row + '"]').trigger('dblclick');
}

export function GetSelected() {
    const selected = []
    try{
        $("#example")
            .dataTable()
            .$("tr.selected")
            .each(function () {
                selected.push($(this).attr("rowId"));
            });
    }
    catch{

    }

    return selected
}
